module.exports = __webpack_public_path__ + "static/img/code.21c9b937.jpg";